import { render, staticRenderFns } from "./newHeader.vue?vue&type=template&id=262e0ce4&scoped=true&"
import script from "./newHeader.vue?vue&type=script&lang=js&"
export * from "./newHeader.vue?vue&type=script&lang=js&"
import style0 from "./newHeader.vue?vue&type=style&index=0&id=262e0ce4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262e0ce4",
  null
  
)

export default component.exports